import get from "lodash/get";
var BillRecipientFormHandler = /** @class */ (function () {
    function BillRecipientFormHandler(modelManager, dirtyForm, options) {
        this.modelManager = modelManager;
        this.dirtyForm = dirtyForm;
        this.options = options;
    }
    BillRecipientFormHandler.prototype.getDirtyRootCartItems = function (state) {
        return get(state, "booking_data.cart_items", [])
            .filter(function (cartItem) { var _a; return (_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.booking) === null || _a === void 0 ? void 0 : _a.course_timespan_id; });
    };
    BillRecipientFormHandler.prototype.deriveBillReceiverIndex = function (state) {
        var fixedBillRecipientIndex = state.getFixedBillRecipient();
        if (fixedBillRecipientIndex !== null) {
            return fixedBillRecipientIndex;
        }
        if (state.hasFixedBillRecipient) {
            return String(0);
        }
        if (state.toWaitList) {
            return String(0);
        }
        if (state.hasTimespanWithoutParticipantForm) {
            return String(0);
        }
        if (state.hasTimespanWithBillRecipient) {
            return String(0);
        }
        var dirtyIndex = state.hasSavedParticipantData() ? state.deriveFixedBillRecipientIndexFromDirtyForm() : null;
        var billRecipientIndex = ![null, undefined].includes(dirtyIndex) ? Number(dirtyIndex) : (state.billRecipientIndex ? Number(state.billRecipientIndex) : 0);
        var hasSeparateBillRecipient = get(this.dirtyForm, "booking_data.has_separate_bill_data", false);
        var excludedParticipantIndices = state.deriveExcludedBillRecipientIndices().map(Number);
        var participantIndices = this.getDirtyRootCartItems(this.dirtyForm)
            .reduce(function (indices, cartItem) { return indices.concat(cartItem.booking.personal_data_index || []); }, [])
            .filter(Boolean)
            .map(Number);
        if (participantIndices.length === 0) {
            return String(billRecipientIndex);
        }
        var filter = function (number) { return !excludedParticipantIndices.includes(number) && !(Number(hasSeparateBillRecipient) ^ Number(participantIndices.includes(number))); };
        if (!filter(billRecipientIndex)) {
            return String(billRecipientIndex);
        }
        for (var counter = 0;; counter++) {
            if (filter(counter)) {
                continue;
            }
            return String(counter);
        }
    };
    BillRecipientFormHandler.prototype.getState = function (state) {
        state.billRecipientIndex = this.deriveBillReceiverIndex(state);
        return state;
    };
    BillRecipientFormHandler.prototype.toJSON = function (sanitizedState) {
        return sanitizedState;
    };
    BillRecipientFormHandler.prototype.toRequestBody = function (sanitizedState, fieldPaths) {
        var billRecipientIndex = sanitizedState.billRecipientIndex, participantIndices = sanitizedState.participantIndices;
        sanitizedState.billRecipientIndex = participantIndices[billRecipientIndex];
        return sanitizedState;
    };
    return BillRecipientFormHandler;
}());
export { BillRecipientFormHandler };
